import scenesTemplate from './scenes.html';

export default angular
  .module('main.locations.edit.tabs.scenes', [])

  .directive('editLocationScenesTab', () => {
    return {
      restrict: 'E',
      template: scenesTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   utils,
                   $rootScope,
                   $log,
                   config,
                   $filter,
                   I18nService,
                   EditLocationDataProvider) => {
        $scope.dataProvider = EditLocationDataProvider.instance;

        const $t = $filter('translate');
        const locationScenes = config.getConfigByKey('locationScenes');
        const sceneSources = config.getConfigByKey('locationSceneSources');
        const occupancyTypes = config.getConfigByKey('locationOccupancyTypes');

        $scope.historyTypes = config.getConfigByKey('locationHistoryTypes');
        $scope.selectedHistoryType = $scope.historyTypes[0].id;
        $scope.locationStatesTimeFormat = $t('datetime.HMS12');
        $scope.dateTimeFormat = $t('datetime.scenes.date');
        let datePickerDateTimeFormat = $t('datetime.scenes.datePickerDate');
        $scope.datepickerButton = $('#toggle-modes-datepicker');
        $scope.locale = I18nService.getLocale();
        $scope.scenes = [];
        $scope.filterDate = null;
        $scope.dateDatePickerOptions = {
          language: $scope.locale.code,
          position: 'bottom left',
          autoClose: true,
          view: 'days',
          minView: 'days',
          dateFormat: datePickerDateTimeFormat,
          maxDate: new Date(),
          timepicker: false,
          clearButton: true,
          range: true,
        };

        angular.extend($scope, {
          onBackButtonClick: onBackButtonClick,
          onGoToSourceButtonClick: onGoToSourceButtonClick,
          onShowMoreButtonClick: onShowMoreButtonClick,
          copyToClipboard: $rootScope.copyToClipboard
        });

        init();

        function init() {
          $scope.loading = true;
          $scope.initialLoading = true;

          initWatchers();

          $q.all([
            $scope.dataProvider.locationIdResource.init(),
            $scope.dataProvider.locationTimeZoneIdResource.init(),
            $scope.dataProvider.locationTimeZoneOffsetResource.init()
          ])
            .then(() => {
              $scope.timezone = $scope.dataProvider.locationTimeZoneIdResource.value;
              $scope.timezoneShift = $scope.dataProvider.locationTimeZoneOffsetResource.value;

              return getLast24HoursHistory();
            })
            .then(() => {
              $scope.loading = false;
              $scope.initialLoading = false;
            })
            .catch((err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
              $scope.initialLoading = false;
            });
        }

        function initWatchers() {
          $scope.$watchGroup(['filterDate', 'selectedHistoryType'], (newValue, oldValue) => {
            if ($scope.initialLoading) {
              return;
            }
            if ($scope.filterDate && $scope.filterDate.length > 0) {
              getExactDateHistory();
            } else if (newValue[0] !== oldValue[0] || newValue[1] !== oldValue[1]) {
              getLast24HoursHistory();
            }
          });
        }

        function getExactDateHistory() {
          $scope.scenes = void 0;

          // filterDate is always array of 1 or 2 date strings.
          let endDateTemp = $scope.filterDate[$scope.filterDate.length - 1];
          let startDate = moment.tz(moment($scope.filterDate[0])
            .format('L'), 'L', $scope.timezone)
            .startOf('day')
            .valueOf();
          let endDate = moment.tz(moment(endDateTemp)
            .format('L'), 'L', $scope.timezone)
            .endOf('day')
            .valueOf();

          $scope.last24Hours = false;
          if (!$scope.selectedHistoryTypeObj || $scope.selectedHistoryTypeObj.type === 'scenes') {
            return getLocationScenesHistory(startDate, endDate);
          } else {
            return getLocationOccupancyHistory(startDate, endDate);
          }
        }

        function getLast24HoursHistory() {
          $scope.scenes = void 0;
          $scope.occupancies = void 0;

          let startDate = new Date().getTime() - 24 * 60 * 60 * 1000;
          let endDate = new Date().getTime();

          $scope.last24Hours = true;
          if (!$scope.selectedHistoryTypeObj || $scope.selectedHistoryTypeObj.type === 'scenes') {
            return getLocationScenesHistory(startDate, endDate);
          } else {
            return getLocationOccupancyHistory(startDate, endDate);
          }
        }

        function getLocationScenesHistory(startDate, endDate) {
          $scope.loading = true;
          return $scope.dataProvider.getLocationScenesHistory(startDate, endDate)
            .then((data) => {
              $scope.loading = false;
              $scope.initialLoading = false;
              $scope.scenes = processLocationScenes(data.events);
            }, (err) => {
              $scope.loading = false;
              $scope.initialLoading = false;
              utils.handleApiError(err);
            });
        }

        /**
         * Process location events (scenes/modes) history.
         * @param {*} newScenes List of history records
         * @param {*} addMore Join new records with existing ones
         * @returns {array}
         */
        function processLocationScenes(newScenes, addMore) {
          const existingScenes = addMore ? $scope.scenes : [];
          if (addMore && (!newScenes || newScenes.length <= 0)) {
            return existingScenes;
          }

          let result = (existingScenes || []).concat(newScenes || [])
            .sort((a, b) => b.eventDateMs - a.eventDateMs);

          // Remove duplicates
          result = result
            .filter((m1, index) =>
              index === result.findIndex(m2 => angular.equals(m1, m2)));

          // Update scenes from config
          result = result.map(el => el = detectScene(el));

          // Update scene source form config
          result = result.map(el => el = getSceneSource(el));

          return result;
        }

        /* Getting location modes from config */
        function detectScene(scene) {
          let result = scene;
          let defaultDetails = {
            name: $t('locations.scenes.defaultMode'),
            color: 'grey',
            icon: 'home'
          };

          if (!result.event) {
            result = Object.assign(result, defaultDetails);
            return result;
          }

          // Search for corresponding scene
          let simplifiedEvent = result.event.split('.')[0];
          let detectedScene = locationScenes.find(el => el.id === simplifiedEvent.toLowerCase()) || {};

          result = Object.assign(result, detectedScene);
          return result;
        }

        /* Getting location mode source details */
        function getSceneSource(scene) {
          let result = scene;

          if (!result || isNaN(result.sourceType)) {
            return result;
          }

          let detectedSource = sceneSources.find(el => el.id === parseInt(result.sourceType)) || {};
          if (detectedSource) {
            result.sourceName = $t(detectedSource.name);
            result.sourceIcon = detectedSource.icon;
            result.sourceColor = detectedSource.color;
          }
          return result;
        }

        function getLocationOccupancyHistory(startDate, endDate) {
          $scope.loading = true;
          return $scope.dataProvider.getLocationOccupancyHistory(startDate, endDate)
            .then((data) => {
              $scope.loading = false;
              $scope.initialLoading = false;
              $scope.occupancies = processLocationOccupancies(data.states);
            }, (err) => {
              $scope.loading = false;
              $scope.initialLoading = false;
              utils.handleApiError(err);
            });
        }

        /**
         * Process location occupancy history.
         * @param {*} newOccupancies List of history records
         * @param {*} addMore Join new records with existing ones
         * @returns {array}
         */
        function processLocationOccupancies(newOccupancies, addMore) {
          const existingOccupancies = addMore ? $scope.occupancies : [];
          if (addMore && (!newOccupancies || newOccupancies.length <= 0)) {
            return existingOccupancies;
          }

          let result = (existingOccupancies || []).concat(newOccupancies || [])
            .sort((a, b) => b.startDate - a.startDate);

          // Remove duplicates
          result = result
            .filter((m1, index) =>
              index === result.findIndex(m2 => angular.equals(m1, m2)));

          // Process occupancy types
          result = result.map(el => {
            const occupancyType = occupancyTypes.find(type => type.value === el.value);
            if (occupancyType) {
              el.name = $t(occupancyType.name);
              el.icon = occupancyType.icon;
            }
            return el;
          });

          return result;
        }

        function onBackButtonClick() {
          $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'events';
        }

        /* Redirects to the related source list */
        function onGoToSourceButtonClick(sourceId, sourceType) {
          let targetTab = 'users';
          if (sourceType === 1) {
            targetTab = 'rules';
          } else if (sourceType === 2) {
            targetTab = 'bots';
          }

          // Redirects to specific tab and search for the source ID
          $scope.dataProvider.activeTab = targetTab;
          $scope.dataProvider.rulesTabSearchValue = targetTab === 'rules' ? sourceId : '';
        }

        function onShowMoreButtonClick() {
          // TODO: Get additional modes from history
        }
      }
    };
  })
  .name;
